import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonDirective } from '@ion-ui/atoms';
import { TranslateModule } from '@ngx-translate/core';
import { TuiNotification } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@taiga-ui/polymorpheus';

import { ModalContext, ModalFooterComponent, ModalHeaderComponent } from '../modal';
import { AlertOptions } from './alert-options.model';

@Component({
  selector: 'ion-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ModalHeaderComponent, TranslateModule, TuiNotification, ModalFooterComponent, ButtonDirective],
})
export class AlertComponent {
  readonly context = inject(POLYMORPHEUS_CONTEXT) as ModalContext<AlertOptions, void>;

  ok(): void {
    this.context.completeWith();
  }
}
